import React from "react";
import PropTypes from 'prop-types';

import Base from "../Base";
import withInput from "../../../hoc/withInput";
import NumberControl from "./NumberControl";

class NumberInput extends Base {
	input() {
		const { inputValue } = this.props;
		
		return(
			<NumberControl
				onChange={ ( newValue ) => {
					this.onChange( newValue );
				} }
				value={ inputValue }
			/>
		);
	}
}


NumberInput.propTypes = {
	inputValue: PropTypes.number,
};

export default withInput( NumberInput );
